import CustomerInner from './CustomerInner';

export default CustomerInner;
